// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/icon/style/index.less
// module id = 1104
// module chunks = 1